<script lang="ts" generics="T">
  import clsx from 'clsx';
  import { generateUniqueElementId } from '@athena-lib/unique-element-id';
  import { Text } from '@athena-lib/Text';
  import FieldLabel from '../FieldLabel/FieldLabel.svelte';
  import type { ProductWizardTextFieldProps } from './types';

  let {
    type,
    placeholder,

    value = $bindable<T>(),
    step,
    id,
    label,
    visuallyHiddenLabel,
    class: className,
    max,
    min,
    name,
    required,
    onChange,
    disabled,
    onInput,
    onFocus,
    onBlur,
    helpText,
  }: ProductWizardTextFieldProps<T> = $props();
  const idToUse = id ?? generateUniqueElementId();
</script>

<div class="w-full">
  {#if label}
    <FieldLabel
      inputId={idToUse}
      {label}
      class="w-full pb-1 font-semibold"
      visuallyHidden={visuallyHiddenLabel}
    />
  {/if}
  <input
    {type}
    {placeholder}
    {min}
    {max}
    bind:value
    {name}
    {required}
    autocomplete={'off'}
    onchange={onChange}
    {disabled}
    oninput={onInput}
    onfocus={onFocus}
    onblur={onBlur}
    {step}
    id={idToUse}
    class={clsx(className, 'w-full rounded-md border border-st-gray-200 px-3 py-2 text-st-black')}
  />
  {#if helpText}
    <Text element="span" size="xsmall">
      {helpText}
    </Text>
  {/if}
</div>
